



import React, {useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import {GripVertical,Minus,Plus,Route,RouteOff,TabletSmartphone,X} from 'lucide-react';
import Toggle from "../../../UI/Toggle";
import ToggleChoice from "../../../UI/ToggleChoices";
import ImageWithFallback from "../../../UI/ImageFallBack";
import UploaderAllCM from "../Uploader/UploaderAllCM";
import { getAllFilesBys3Key } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";

  
const OptionTitleAddMore=({index ,questionType,optionImageStatus,draggableImageStatus,optionImageKey,draggableImageKey,changeOptionImage, changeDraggableImage,changeOptionImageStatus, changeDraggableImageStatus,
    optionTitle,optionTitle2,id,onRemove,changeItemOptionTitle,changeItemOptionTitle2,choiceType,choiceCorrect,setChoiceCorrect,allowPartialMarksStatus,updateAllowPartialMarks,partialMarksChoiceValue,setPartialMarksChoiceBack})=>{
  
  
  
      const App = useSelector((state)=>state?.app?.app);
      const [Courses,setCourses] =useState([])
      const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
       const [animate, setAnimate] = useState(false);
       
      const dispatch = useDispatch();  
    
      const currentToken = useSelector((state)=>state?.user?.user?.token);
      const user_email = useSelector((state)=>state?.user?.user?.user_email
     );
     const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
     const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
     const [snackbarVisible, setSnackbarVisible] = useState(false);
      
      const [snackbarColor, setSnackbarColor] = useState("#958FDA");
      const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      const showSnackbar = () => {
       setSnackbarVisible(true);
     };
     
      const hideSnackbar = () => {
       setSnackbarVisible(false);
     };
     const setCurrentCourse=()=>{
      dispatch({
          type: "COURSEDATA",
          
          payload:""
        });  
  }
         const [loader , setLoader] =useState({status:false});
        const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          } 
    const [itemOptionTitle, setItemOptionTitle] = useState(optionTitle); 
    const [itemOptionTitle2, setItemOptionTitle2] = useState(optionTitle2); 
   const [isChoiceCorrect, setIsChoiceCorrect] = useState(choiceCorrect); 
   const [allowPartialMarks, setAllowPartialMarks] = useState(allowPartialMarksStatus); 
   const [partialMarksChoice, setPartialMarksChoice] = useState(partialMarksChoiceValue); 
   const [optionImage, setOptionImage] = useState(optionImageStatus); 
   const [draggableImage, setDraggableImage] = useState(draggableImageStatus); 
     const [openUploaderPopUp ,setOpenUploaderPopUp] = useState(false)
     const [currentFileObject1,setCurrentFileObject1] = useState({}); 
     const [currentFileObject2,setCurrentFileObject2] = useState({}); 
         const [currentFile1,setCurrentFile1] = useState(""); 
         const [currentFile2,setCurrentFile2] = useState(""); 
           const [currentFileType, setCurrentFileType] = useState({});
           
         const [uploaderPopUpType,setUploaderPopUpType] = useState(""); 


      const fireFetchFileLinkByS3Key=(thumbnailKey,keyType)=>{
          
                      
          setLoader({status:true});
            const apiData = dispatch(getAllFilesBys3Key({userEmail:user_email?user_email:null,
            currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,fileKey:thumbnailKey,
            editType:"getFileListByS3Key"}));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){
        
                
                if(response){
                  if(keyType=="optionImg"){
                    setCurrentFile1(response?.file?.file)
                setCurrentFileObject1(response?.file)
                  }  if(keyType=="draggableImg"){
                    setCurrentFile2(response?.file?.file)
                setCurrentFileObject2(response?.file)
                  }
                
               
      
             }else{
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
             }
                
             
             if(response?.logout){
             
              setResponseMessage("You are Logged Out!!!");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              setTimeout(()=>{
                dispatch({type:"LOGOUT"});
          
              },3000)
              
            }
          /* resetting Login input Fields */
          
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            });
           
            }
    
     useEffect(()=>{
     fireFetchFileLinkByS3Key(optionImageKey,"optionImg");
     fireFetchFileLinkByS3Key(draggableImageKey,"draggableImg");
     },[optionImageKey,draggableImageKey])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<><div 
   
   
   style={{padding:"5px",margin:"5px", marginTop:"10px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"2px solid rgba(144, 202, 249,1)"}}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"10px",
      background:"#958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
    
 
<div  style={{}}>
    <div>
    <div className="YoutubeVideoLinkCardInner"  > 
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"50px",height:"40px",
      borderRadius:"50%",
       alignContent:"center",textAlign:"center",padding:"5px",position:"relative",left:"-20px"}}>
          <GripVertical color="#958FDA" size={22} />
          </div> 
           {questionType!=="Drag Matching"?<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={3} value={itemOptionTitle} type="text"
     placeholder={(index+1)+": Add  Choice Name  "}
        onChange={(e)=>{handleChange(e);changeItemOptionTitle(id,e.target.value);setItemOptionTitle(e.target.value);}}
        style={{height:"50px",minWidth:"150px",marginTop:"2px",fontSize:"15px"}}  className="inputTextCardSkills"></textarea>:""}  </div>
   {/* <div style={{float:"right",padding:"15px"}}>

   <div  className="coloredTextV1" >
        Word count: {wordCount} / 50
      </div>
    </div> 
     */}
     
    </div> 
   
        
        
    


 {questionType=="Drag Matching"? <>
 <div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> <div className="" style={{display:"flex",justifyContent:"space-around",}}>
    <div style={{fontSize:"14px",fontWeight:"bold",padding:"5px",marginTop:"5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Draggable Text</div> 
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={3} value={itemOptionTitle2} type="text"
     placeholder={(index+1)+": Add  Choice Name  "}
        onChange={(e)=>{handleChange(e);changeItemOptionTitle2(id,e.target.value);setItemOptionTitle2(e.target.value);}}
        style={{height:"50px",minWidth:"150px",marginTop:"2px",fontSize:"15px"}}  className="inputTextCardSkills"></textarea>} 
        </div>
 <div  style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",height:"30px",padding:"5px",margin:"5px",border:"2px solid #fff",}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div  style={{marginTop:"-15px"}}><h5>{"Add Draggable Image?"} </h5></div>
            <ToggleChoice type={"checkbox"} name="allowPartialMarks1" state={draggableImage} 
            toggleState={(state)=>{setDraggableImage(state);changeDraggableImageStatus(id,state) ;;}} />
      </div>
       </div>
       {/* <div className="" style={{display:"flex",justifyContent:"space-around", border:"2px solid #fff",background:"rgba(144, 202, 249,0.1)",borderRadius:"10px",marginTop:"10px",marginLeft:"5px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
 <div style={{fontSize:"14px",fontWeight:"bold",padding:"5px",marginTop:"5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                <div style={{width:"80px"}}>{ "Draggable Item Position"}</div> </div> <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={3} value={index+1} type="number"
     placeholder={"Item Position"}
        onChange={(e)=>{}}
        style={{height:"50px",minWidth:"150px",marginTop:"2px",fontSize:"15px"}}  className="inputTextCardSkills"/> </div> */}
 {draggableImage?<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
    <div style={{fontSize:"14px",fontWeight:"bold",padding:"10px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Draggable Image</div>   <div>
                    
                    {currentFile2?<ImageWithFallback src={currentFile2} widthOuter={"70px"} fireOpenEdit ={()=>{setUploaderPopUpType("draggableImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setUploaderPopUpType("draggableImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:""}
 </div> <div>
  <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setUploaderPopUpType("draggableImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
 > Upload Image </button>
 </div>
 </div>:""}
 </div>
 </>:""}       {questionType=="Drag Matching"?  
           <><div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> <div className="" style={{display:"flex",justifyContent:"space-around",}}>
    <div style={{fontSize:"14px",fontWeight:"bold",padding:"5px",marginTop:"5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Option Text</div> 
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={3} value={itemOptionTitle} type="text"
     placeholder={(index+1)+": Add  Choice Name  "}
        onChange={(e)=>{handleChange(e);changeItemOptionTitle(id,e.target.value);setItemOptionTitle(e.target.value);}}
        style={{height:"50px",minWidth:"150px",marginTop:"2px",fontSize:"15px"}}  className="inputTextCardSkills"></textarea>} 
        </div><div  style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",height:"30px",padding:"5px",margin:"5px",border:"2px solid #fff",}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div  style={{marginTop:"-15px"}}><h5>{"Add Option Image?"} </h5></div>
            <ToggleChoice type={"checkbox"} name="allowPartialMarks1" state={optionImage} 
            toggleState={(state)=>{setOptionImage(state);changeOptionImageStatus(id,state) ;;}} />
      </div> </div>
          {optionImage? <div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
    <div style={{fontSize:"14px",fontWeight:"bold",padding:"10px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Option Image  </div>   <div>
                    
                    {currentFile1?<ImageWithFallback src={currentFile1} widthOuter={"70px"} fireOpenEdit ={()=>{setUploaderPopUpType("optionImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setUploaderPopUpType("optionImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:""}
 </div> <div>
  <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setUploaderPopUpType("optionImg");setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
 > Upload Image </button>
 </div>
 </div>:""}</div></>:""}
   {questionType!=="Drag Matching"? <div  style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",height:"30px",padding:"5px",margin:"5px"}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div style={{marginTop:"-15px"}}><h5>{"Is This Choice Correct?"} </h5></div>
            <ToggleChoice type={questionType=="MSQ"?"checkbox":questionType=="MCQ"?"checkbox":"checkbox"} name="choiceCorrect1" state={isChoiceCorrect} 
            toggleState={(state)=>{ setIsChoiceCorrect(state);setChoiceCorrect(id,state) ;}} />
      </div>
                              
                              </div>:""}
                         
     {questionType=="MSQ"||questionType=="Drag Matching"? <div  style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"15px",height:"30px",padding:"5px",margin:"5px"}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}><div  style={{marginTop:"-15px"}}><h5>{"Allow Partial Marks For This Choice?"} </h5></div>
            <ToggleChoice type={"checkbox"} name="allowPartialMarks1" state={allowPartialMarks} 
            toggleState={(state)=>{setAllowPartialMarks(state); ;updateAllowPartialMarks(id,state) ;;}} />
      </div> </div>:""}
         {(questionType=="MSQ"||questionType=="Drag Matching")&&allowPartialMarks?
      <div style={{background:"#ffffff",margin:"5px",display:"grid", gridTemplateColumns: "40% 60%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                          <div style={{fontSize:"16px",fontWeight:"bold",paddingLeft:"10",padding:"8px",paddingTop:"15px"}}>
                           Partial   Marks For Choice  (+)</div>         
                     <div style={{margin: '5px' ,paddingLeft:"20px",width:"150px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
       <Minus  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave}  onClick={()=>{setPartialMarksChoice(parseFloat(partialMarksChoice)>0?parseFloat(partialMarksChoice)-0.5:0)
       ; setPartialMarksChoiceBack(id,parseFloat(partialMarksChoice)>0?parseFloat(partialMarksChoice)-0.5:0)
        }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
              alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
          <input onMouseEnter={handleMouseEnter} 
           onMouseLeave={handleMouseLeave}  value={partialMarksChoice?parseFloat(partialMarksChoice):0} type="number"
                onChange={(e)=>{
                  ;
                  ;setPartialMarksChoice(parseFloat(e.target.value)<100?parseFloat(e.target.value):0);
                setPartialMarksChoiceBack(id,parseFloat(e.target.value)<100?parseFloat(e.target.value):0)}}
                style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",marginLeft:"-5px",
                  padding:"0px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
            />  <Plus onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}  
            onClick={()=>{setPartialMarksChoice(parseFloat(partialMarksChoice)<100?parseFloat(partialMarksChoice)+0.5:0)
            setPartialMarksChoiceBack(id,parseFloat(partialMarksChoice)<100?parseFloat(partialMarksChoice)+0.5:0)
              ; 
            
            }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
              alignContent:"center",textAlign:"center",marginLeft:"-5px",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
              
              
              
              </div> 
              
              </div>:""}
    </div>
    {openUploaderPopUp?<UploaderAllCM
    
      fileTypeObject={[currentFileType]}
                     selectedFileObject={uploaderPopUpType=="draggableImg"?currentFileObject2:uploaderPopUpType=="optionImg"?currentFileObject1:""} currentFileObject={uploaderPopUpType=="draggableImg"?currentFileObject2:uploaderPopUpType=="optionImg"?currentFileObject1:""} setCurrentFileObject={(v)=>{if(uploaderPopUpType=="draggableImg"){setCurrentFileObject2(v);changeDraggableImage(id,v?.file_s3_key)};if(uploaderPopUpType=="optionImg"){setCurrentFileObject1(v);changeOptionImage(id,v?.file_s3_key)};}} setCloseUploaderPopUp={()=>{setOpenUploaderPopUp(false)}} />:""}
  
    </div></>)
}  

export default OptionTitleAddMore;
